import { Flex, Icon, Text } from '@chakra-ui/react';
import { FaLightbulb, FaPencilAlt } from 'react-icons/fa';
import React from 'react';

export const timestampToMinutes = (timestamp: number): string => {
  const seconds = timestamp;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const time = `${minutes}:${
    remainingSeconds < 10 ? '0' : ''
  }${remainingSeconds}`;
  return time;
};

const MarkerIdea = ({ prompt, onClick }: any) => {
  return (
    <Flex flexDir="column" alignItems="center" gap={2} onClick={onClick}>
      <Text
        bg="white"
        color="black"
        fontSize={10}
        px={10}
        borderRadius="8"
        w="fit-content"
      >
        {timestampToMinutes(prompt.timestamp)}
      </Text>
      <Flex
        justifyContent="center"
        alignItems="center"
        bg="var(--chakra-colors-newGreen-500)"
        borderRadius="100%"
        p={2}
        h="22px"
        w="22px"
      >
        <Icon as={FaLightbulb} fontSize={14} color="black" />
      </Flex>
    </Flex>
  );
};
const MarkerNotion = ({ prompt, onClick }: any) => {
  return (
    <Flex flexDir="column" alignItems="center" gap={2} onClick={onClick}>
      <Text
        bg="white"
        color="black"
        fontSize={10}
        px={10}
        borderRadius="8"
        w="fit-content"
      >
        {timestampToMinutes(prompt.timestamp)}
      </Text>
      <Flex
        justifyContent="center"
        alignItems="center"
        bg="var(--chakra-colors-red-500)"
        borderRadius="100%"
        p={2}
        h="22px"
        w="22px"
      >
        <Icon as={FaPencilAlt} fontSize={12} color="white" />
      </Flex>
    </Flex>
  );
};
export const Marker = ({ prompt, onClick }: any) => {
  if (prompt.prompt_type_id === 1) {
    return <MarkerIdea prompt={prompt} onClick={onClick} />;
  }
  if (prompt.prompt_type_id === 2) {
    return <MarkerNotion prompt={prompt} onClick={onClick} />;
  }
  return null;
};
